import { twMerge } from "tailwind-merge";
import type { IconProps } from "./types";

export const IpenNumber = ({ size, color, className, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={twMerge(
      color == null && "h-5 w-5 fill-current",
      className,
      "stroke-none",
    )}
    fill={color}
    stroke="none"
    {...props}
  >
    <path d="M2.66972 8.72705V15.9998H1.13208V8.72705H2.66972Z" fill="black" />
    <path d="M3.93481 15.9998V8.72705H6.80413C7.35574 8.72705 7.82568 8.8324 8.21393 9.0431C8.60219 9.25144 8.89812 9.54144 9.10172 9.91313C9.30768 10.2824 9.41067 10.7086 9.41067 11.1915C9.41067 11.6745 9.3065 12.1006 9.09817 12.4699C8.88983 12.8393 8.58799 13.1269 8.19263 13.3329C7.79963 13.5388 7.32378 13.6418 6.76507 13.6418H4.93623V12.4096H6.51649C6.81242 12.4096 7.05626 12.3587 7.24802 12.2569C7.44215 12.1527 7.58657 12.0095 7.68126 11.8272C7.77833 11.6425 7.82686 11.4306 7.82686 11.1915C7.82686 10.9501 7.77833 10.7394 7.68126 10.5594C7.58657 10.3771 7.44215 10.2363 7.24802 10.1369C7.0539 10.0351 6.80768 9.98415 6.50939 9.98415H5.47246V15.9998H3.93481Z" />
    <path d="M10.4094 15.9998V8.72705H15.31V9.99481H11.9471V11.7278H15.0579V12.9955H11.9471V14.732H15.3242V15.9998H10.4094Z" />
    <path d="M22.6156 8.72705V15.9998H21.2874L18.1234 11.4224H18.0701V15.9998H16.5325V8.72705H17.8819L21.0211 13.3009H21.085V8.72705H22.6156Z" />
  </svg>
);
